<top-navig [displayLogo]="false" title="Connexion"></top-navig>
<div class="div-bag"></div>
<div class="omber"></div>
<div class="signupContent" [class.mp-97]="ourApp">
    <div class="text-center logo">
        <img src="assets/images/logo2.png" alt="logo" width="170px">
    </div>
    <form class="login100-form validate-form">
        <ng-container *ngIf="step == 1">
            <div class="wrap-input100 validate-input">
                <input class="input100" type="text" [(ngModel)]="customer.email" name="email" placeholder="Email">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input">
                <input class="input100" type="password" [(ngModel)]="customer.password" spellcheck=false name="pass"
                    placeholder="Mot de Passe">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
        </ng-container>
        <ng-container *ngIf="step == 2">
            <div class="wrap-input100 validate-input">
                <input class="input100" type="text" [(ngModel)]="phone" name="phone" placeholder="Téléphone">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
        </ng-container>
        <ng-container *ngIf="step == 1">
            <div class="container-login100-form-btn">
                <button class="login100-form-btn" (click)="login()" [disabled]="loader">
                    <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                    </ng-container>
                    Connexion
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="step == 2">
            <div class="container-login100-form-btn">
                <button class="login100-form-btn" (click)="valide()" [disabled]="loader">
                    <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                    </ng-container>
                    Valider
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="step == 1">
            <div class="google-btn" (click)="signIn('google')">
                <div class="google-icon-wrapper">
                    <img class="google-icon"
                        src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" />
                </div>
                <p class="btn-text"><b>Connectez-vous avec Google</b></p>
            </div>

            <div class="fc-btn" (click)="signIn('facebook')">
                <div class="fc-icon-wrapper">
                    <img class="fc-icon" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png" />
                </div>
                <p class="btn-text"><b>Connectez-vous avec Facebook</b></p>
            </div>
        </ng-container>


        <div class="footer">
            <table width="100%">
                <tr>
                    <td>
                        <a class="txt2 cursor-pointer" routerLink="../recuperation/mdp">
                            Mot de passe oublié?
                        </a>
                    </td>
                    <td class="a1">
                        <button routerLink="../inscription" class="login-btn">
                            S'inscrire &nbsp;&nbsp;
                            <i class="glyphicon glyphicon-arrow-right"></i>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    </form>
</div>